export enum SessionTaggingState {
  InitialLineupSet = 'InitialLineupSet',
  SessionSubmittedByTagger = 'SessionSubmittedByTagger',
  SessionSubmittedBySystem = 'SessionSubmittedBySystem',
  SessionAdjustedByCleaner = 'SessionAdjustedByCleaner',
}
